<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm class="elementui-common-form-styles" v-highlight label-width="0" inline>
        <ElFormItem>
          <ElInput v-model.trim="keyword" placeholder="请输入计划名称" style="width: 180px">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem
          :label-width="config.showLabel ? '60' : '0'"
          v-for="config in selectConfigData"
          :key="config.id"
          :label="config.showLabel && config.placeholder"
        >
          <el-select
            v-model="_this[config.valueKey]"
            :multiple="config.multiple"
            :placeholder="config.placeholder"
            collapse-tags
            filterable
            clearable
            :style="`width: ${config.width}px`"
          >
            <el-option v-for="item in _this[config.dataKey]" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <DateRangePicker v-model="datetime" @change="search" style="width: 220px"></DateRangePicker>
        </ElFormItem>
        <ElButton type="primary" class="search-button" @click="search"> 查询 </ElButton>
      </ElForm>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { isArray } from '@/common/js/utils'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import { queryHasAuthGroup, queryHasAuthOperator, queryHasAuthPopularGame } from '@/api/common.model'
import { initPageData, GAME_GROUPS, MEDIAS, MEDIA_POSITION, MEDIA_ACCOUNTS, AGENTS } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, MEDIAS, MEDIA_POSITION, MEDIA_ACCOUNTS, AGENTS])

export default {
  name: 'TrackPlanFilter',
  components: { DateRangePicker },

  computed: {
    ...PAGE_REQUIRED_OPTS,
    _this() {
      return this
    }
  },
  created() {
    this.getAuthPageData()
  },
  methods: {
    getAuthPageData() {
      Promise.all([queryHasAuthGroup(), queryHasAuthOperator(), queryHasAuthPopularGame()]).then((data) => {
        const [projectGroupData, authOpData, authAppData] = data
        if (isArray(projectGroupData)) {
          this.projectGroupData = projectGroupData.map((ret) => {
            return {
              id: ret.id,
              name: ret.name
            }
          })
        }
        if (isArray(authOpData)) {
          this.authOpData = authOpData.map((ret) => {
            return {
              id: ret.opId,
              name: ret.name
            }
          })
        }
        if (isArray(authAppData)) {
          this.authAppData = authAppData.map((ret) => {
            return {
              id: ret.productId,
              name: ret.productName
            }
          })
        }
      })
    },
    search() {
      this.$emit('on-search')
    },
    buildParams() {
      const [beginTime, endTime] = this.datetime || ['', '']
      const params = {
        planName: this.keyword,
        platforms: this.platforms,
        projectGroupOpIds: this.projectGroupIds.join(','),
        opIds: this.opIds,
        gameGroupIds: this.gameGroupIds,
        gameIds: this.gameIds,
        mediaIds: this.mediaIds,
        advPositionIds: this.advPositionIds,
        adAccountIdList: this.adAccountIdList,
        proxyAccountId: this.proxyAccountId,
        imageFlag: this.imageFlag,
        packageStatus: this.packageStatus,
        field3: this.isWhiteList,
        beginTime,
        endTime
      }
      for (const key of Object.keys(params)) {
        if (!params[key] && params[key] !== 0) delete params[key]
        else if (isArray(params[key]) && !params[key].length) delete params[key]
      }

      return params
    }
  },
  data() {
    return {
      datetime: [moment().subtract(2, 'years').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      keyword: '',
      platforms: [],
      projectGroupIds: [],
      opIds: [],
      gameGroupIds: [],
      gameIds: [],
      mediaIds: [],
      advPositionIds: [],
      adAccountIdList: [],
      proxyAccountId: '',
      imageFlag: '',
      packageStatus: '',
      isWhiteList: '',
      projectGroupData: [],
      authOpData: [],
      authAppData: [],
      platformData: [
        { id: 1, name: '安卓' },
        { id: 2, name: 'iOS' },
        { id: 3, name: '小程序' },
        { id: 5, name: '鸿蒙' }
      ],
      materialSelectData: [
        { id: 0, name: '是' },
        { id: 1, name: '否' }
      ],
      packStatusData: [
        { id: 0, name: '待打包' },
        { id: 1, name: '正在打包' },
        { id: 2, name: '打包完成' },
        { id: 3, name: '打包失败' },
        { id: 4, name: '正在批量打包' }
      ],
      whiteListData: [
        { id: 1, name: '包体持续更新白名单' },
        { id: 0, name: '包体正常更新' },
        { id: 2, name: '包体已废弃' }
      ],
      selectConfigData: [
        {
          id: 1,
          placeholder: '平台',
          dataKey: 'platformData',
          valueKey: 'platforms',
          multiple: true,
          showLabel: true,
          width: 180
        },
        {
          id: 2,
          placeholder: '项目组',
          dataKey: 'projectGroupData',
          valueKey: 'projectGroupIds',
          multiple: true,
          showLabel: true,
          width: 180
        },
        {
          id: 3,
          placeholder: '人员',
          dataKey: 'authOpData',
          valueKey: 'opIds',
          multiple: true,
          showLabel: true,
          width: 180
        },
        {
          id: 4,
          placeholder: '应用组',
          dataKey: 'GAME_GROUPS',
          valueKey: 'gameGroupIds',
          multiple: true,
          showLabel: true,
          width: 180
        },
        {
          id: 5,
          placeholder: '应用',
          dataKey: 'authAppData',
          valueKey: 'gameIds',
          multiple: true,
          showLabel: true,
          width: 180
        },
        {
          id: 6,
          placeholder: '媒体',
          dataKey: 'MEDIAS',
          valueKey: 'mediaIds',
          multiple: true,
          showLabel: true,
          width: 180
        },
        {
          id: 7,
          placeholder: '投放位',
          dataKey: 'MEDIA_POSITION',
          valueKey: 'advPositionIds',
          multiple: true,
          showLabel: true,
          width: 160
        },
        {
          id: 8,
          placeholder: '账号',
          dataKey: 'MEDIA_ACCOUNTS',
          valueKey: 'adAccountIdList',
          multiple: true,
          showLabel: true,
          width: 180
        },
        {
          id: 12,
          placeholder: '代投账号',
          dataKey: 'AGENTS',
          valueKey: 'proxyAccountId',
          multiple: false,
          showLabel: true,
          width: 180
        },

        {
          id: 9,
          placeholder: '是否素材选择',
          dataKey: 'materialSelectData',
          valueKey: 'imageFlag',
          width: 100
        },
        {
          id: 10,
          placeholder: '打包状态',
          dataKey: 'packStatusData',
          valueKey: 'packageStatus',
          width: 100
        },
        {
          id: 11,
          placeholder: '包体更新状态',
          dataKey: 'whiteListData',
          valueKey: 'isWhiteList',
          width: 100
        }
      ]
    }
  }
}
</script>
